import Helpers from "../../commons/helpers";
import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";

const UserGroupService = {

    async getDetail(data: {
        userId: string,
        organizationId: string,
        clientId?: string,
    }) {
        const newData = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.GROUP_USER.GET_DETAIL}?${newData}`);
        return result.data.result;
    },

    async create(data: {
        userId: string,
        organizationId: string,

        groupId: string,
        manager: number,
        default: number,
        userTitle: string,
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.GROUP_USER.CREATE, data);
        return result.data;
    },

    async update(data: {
        id: string,
        organizationId: string,
        userId: string,
        groupId: string,
        manager: number,
        default: number,
        userTitle: string,
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.GROUP_USER.UPDATE, data);
        return result.data;
    },

    async delete(data: {
        id: string,
        organizationId: string,
        isInvitationDetail: boolean
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.GROUP_USER.DELETE, data);
        return result.data;
    },
}

export default UserGroupService